import { render, staticRenderFns } from "./addUniversity.vue?vue&type=template&id=4b1d6ed8&scoped=true"
import script from "./addUniversity.vue?vue&type=script&lang=js"
export * from "./addUniversity.vue?vue&type=script&lang=js"
import style0 from "./addUniversity.vue?vue&type=style&index=0&id=4b1d6ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d6ed8",
  null
  
)

export default component.exports